import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const DemoPage = lazy(() => import('../pages/demo/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const AgentManagementPage = lazy(() => import('../pages/agent-management/page'));
const PurchasePage = lazy(() => import('../pages/purchase/page'));
const PurchaseSuccessPage = lazy(() => import('../pages/purchase-success/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/demo',
    element: <DemoPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/agent-management',
    element: <AgentManagementPage />,
  },
  {
    path: '/purchase',
    element: <PurchasePage />,
  },
  {
    path: '/purchase-success',
    element: <PurchaseSuccessPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;